
// import GDPRPolicyLink from "../components/GDPRPolicyLink";

// import { useState, useRef } from "react";
// import { useStateContext } from "../context/ContextProvider";
// import {
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormControl,
//   FormLabel,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   InputAdornment,
//   Checkbox,
//   Alert,
// } from "@mui/material";
// import { SketchPicker } from "react-color";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import PhoneField from "../components/PhoneField";
// import { IconButton } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// const UserForm = () => {
//   const nameRef = useRef(null);
//   const surnameRef = useRef(null);
//   const dateRef = useRef(null);
//   // const usernameRef = useRef(null);
//   const passwordRef = useRef(null);
//   const emailRef = useRef(null);
//   const addressRef = useRef(null);
//   const gesyNumberRef = useRef(null);

//   const postalRef = useRef(null);
//   const cityRef = useRef(null);
//   const cardNumberRef = useRef();
//   const [gender, setGender] = useState("");
//   const [role, setRole] = useState("CLIENT");
//   const [error, setError] = useState();
//   const [message, setMessage] = useState();
//   const [color, setColor] = useState("");
//   const [phone, setPhone] = useState("+357");
//   const [hardcopyConsent, setHardcopyConsent] = useState(false);

//   const [errors, setErrors] = useState({});

//   const { token } = useStateContext();
//   const { t } = useTranslation();
//   const [showPassword, setShowPassword] = useState(false);

//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();

//     let phoneNumber = "+" + phone;

//     if (dateRef.current.value && !/^\d{4}-\d{2}-\d{2}$/.test(dateRef.current.value)) {
//       setErrors({ ...errors, date_birth: "Invalid date format. Use YYYY-MM-DD" });
//       return;
//     }
//     let localErrors = {};
//     // const usernameVal = usernameRef.current.value;
//     const passwordVal = passwordRef.current.value;
//     const nameVal = nameRef.current.value;
//     const surnameVal = surnameRef.current.value;
//     const emailVal = emailRef.current.value;
//     const phoneVal = phone;

//     // const usernameHasTwoDigits = (usernameVal.match(/\d/g) || []).length >= 2;

//     // if (!usernameVal) {
//     //   localErrors.username = "Username is required";
//     // } else if (usernameVal.length < 3 || !usernameHasTwoDigits) {
//     //   localErrors.username = "Username must be at least 3 characters and contain at least 2 digits";
//     // }

//     if (!passwordVal) {
//       localErrors.password = "Password is required";
//     } else if (
//       passwordVal.length < 8 ||
//       !/[!@#$%^&*(),.?":{}|<>]/.test(passwordVal)
//     ) {
//       localErrors.password = "Password must be at least 8 characters long with at least 1 special character";
//     }

//     if (!nameVal || nameVal.length < 2) localErrors.first_name = "First name must be at least 2 characters";
//     if (!surnameVal || surnameVal.length < 2) localErrors.last_name = "Last name must be at least 2 characters";

//     if (!emailVal) {
//       localErrors.email = "Email is required";
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
//       localErrors.email = "Invalid email format";
//     }

//     if (!phoneVal || phoneVal.trim() === "" || phoneVal === "+357") {
//       localErrors.phone_number = "Phone number is required";
//     }

//     if (Object.keys(localErrors).length) {
//       setErrors(localErrors);
//       return;
//     }

//     const payload = {
//       user_role: role,
//       username: emailRef.current.value,
//       password: passwordRef.current.value,
//       first_name: nameRef.current.value,
//       last_name: surnameRef.current.value,
//       email: emailRef.current.value,
//       date_birth: dateRef.current.value || null,
//       hardcopy_consent: hardcopyConsent,
//       gender: gender,
//       phone_number: phoneNumber,
//       ...(role !== "CLIENT" && role !== "ADMIN" && {
//         // id_card: cardNumberRef.current.value, 
//         // city: cityRef.current?.value || "",
//         // address: addressRef.current?.value || "",
//         // postcode: postalRef.current?.value || "",
//         gesy_number: gesyNumberRef.current?.value || "",
//         color: color,
//       }),
//     };

//     axiosClient
//       .post("/api/user/", payload, {
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "*/*",
//           Authorization: `JWT-${token}`,
//         },
//       })
//       .then((res) => {
//         console.log("res", res);
//         setError({});
//         setMessage("User added successfully");
//         setError();
//         // usernameRef.current.value = null;
//         passwordRef.current.value = null;
//         if (cardNumberRef.current) cardNumberRef.current.value = null;
//         setHardcopyConsent(false);
//         nameRef.current.value = null;
//         surnameRef.current.value = null;
//         emailRef.current.value = null;
//         dateRef.current.value = null;
//         setGender("");
//         if (cityRef.current) cityRef.current.value = null;
//         if (addressRef.current) addressRef.current.value = null;
//         if (postalRef.current) postalRef.current.value = null;
//         if (gesyNumberRef.current) gesyNumberRef.current.value = null;
//         setPhone("+357");
//         setColor("");
//       })
//       .catch((err) => {
//         const allIssues = Object.keys(err.response?.data || {});
//         if (err?.response?.data?.code) {
//           setError(err.response.data.code);
//           return;
//         }
//         setError(
//           allIssues.length
//             ? err.response?.data[allIssues[0]][0] ||
//             "Some input is invalid! please try again"
//             : "Some input is invalid! please try again"
//         );
//         console.log("error when creating new user", err);
//         setErrors(err.response?.data);
//       });
//   };


//   const handleReset = () => {
//     setRole("CLIENT");
//     setShowPassword(false);
//     setGender("");
//     setPhone("+357");
//     setColor("");
//     setError(undefined);
//     setMessage(undefined);
//     setErrors({});
//     setHardcopyConsent(false);

//     const refs = [
//       nameRef,
//       surnameRef,
//       dateRef,
//       // usernameRef,
//       passwordRef,
//       emailRef,
//       addressRef,
//       gesyNumberRef,
//       postalRef,
//       cityRef,
//       cardNumberRef
//     ];

//     refs.forEach((ref) => {
//       if (ref.current) ref.current.value = "";
//     });
//   };

//   const handleGenderChange = (event) => {
//     setGender(event.target.value);
//   };

//   const handleRoleChange = (event) => {
//     setRole(event.target.value);
//     setErrors({ ...errors, user_role: "" });
//   };

//   return (
//     <Card elevation={16}>
//       <CardContent>
//         <Typography variant="h5" gutterBottom sx={{ fontSize: "1.2rem" }}>
//           {t("Information")}
//         </Typography>
//         <form onSubmit={handleSubmit}>
//           <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
//             <FormLabel component="legend" sx={{ mr: 2, fontSize: "0.9rem" }}>
//               {t("Role")}
//             </FormLabel>
//             <RadioGroup
//               name="role"
//               value={role}
//               onChange={handleRoleChange}
//               row
//               sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }}
//             >
//               <FormControlLabel value="ADMIN" control={<Radio size="small" />} label={t("Secretary")} />
//               <FormControlLabel value="STAFF" control={<Radio size="small" />} label={t("Doctor")} />
//               <FormControlLabel value="CLIENT" control={<Radio size="small" />} label={t("Patient")} />
//             </RadioGroup>
//           </Box>

//           {errors?.user_role && (
//             <Typography
//               sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//               color="error"
//               variant="body1"
//             >
//               {errors?.user_role}
//             </Typography>
//           )}
//           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//             <FormControlLabel
//               control={<Checkbox checked={hardcopyConsent} onChange={(e) => setHardcopyConsent(e.target.checked)} size="small" />}
//               label={t("Hardcopy Consent")}
//               sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }}
//             />
//           </Box>
//           <Box sx={{ "& .MuiTextField-root": { marginBottom: "0.8rem" } }}>
//             <TextField
//               fullWidth
//               label={t("Name")}
//               variant="outlined"
//               inputRef={nameRef}
//               InputLabelProps={{
//                 required: true,
//                 sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
//               }}
//               InputProps={{
//                 sx: { fontSize: "0.9rem" },
//               }}
//               onChange={(e) => setErrors({ ...errors, first_name: "" })}
//             />
//             {errors?.first_name && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.first_name}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               label={t("Surname")}
//               variant="outlined"
//               inputRef={surnameRef}
//               InputLabelProps={{
//                 required: true,
//                 sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
//               }}
//               InputProps={{
//                 sx: { fontSize: "0.9rem" },
//               }}
//               onChange={(e) => setErrors({ ...errors, last_name: "" })}
//             />
//             {errors?.last_name && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.last_name}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               type="date"
//               label={t("Date of Birth")}
//               variant="outlined"
//               InputLabelProps={{
//                 shrink: true,
//                 sx: { fontSize: "0.9rem" },
//               }}
//               inputRef={dateRef}
//               onChange={(e) => setErrors({ ...errors, date_birth: "" })}
//               InputProps={{
//                 sx: {
//                   fontSize: "0.9rem",
//                   "&::-webkit-calendar-picker-indicator": {
//                     filter: "invert(1)",
//                   },
//                 },
//               }}
//             />
//             {errors?.date_birth && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.date_birth}
//               </Typography>
//             )}
//             {/* {role !== "CLIENT" && (
//               <>
//                 <TextField
//                   fullWidth
//                   label={t("GESY NUMBER")}
//                   variant="outlined"
//                   inputRef={gesyNumberRef}
//                 />
//                 <TextField
//                   fullWidth
//                   label={t("Postal code")}
//                   variant="outlined"
//                   inputRef={postalRef}
//                 />
//                 <TextField
//                   fullWidth
//                   label={t("City")}
//                   variant="outlined"
//                   inputRef={cityRef}
//                 />
//               </>
//             )} */}
//             <PhoneField phone={phone} setPhone={(val) => {
//               setPhone(val);
//               setErrors((prev) => ({ ...prev, phone_number: "" }));
//             }}
//               textFieldProps={{
//                 InputLabelProps: { sx: { fontSize: "0.9rem" } },
//                 InputProps: { sx: { fontSize: "0.9rem" } },
//               }}
//             />
//             {errors?.phone_number && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.phone_number}
//               </Typography>
//             )}
//             {/* {role !== "CLIENT" && (
//             <>
//             <TextField
//               fullWidth
//               label={t("ID Number")}
//               variant="outlined"
//               required
//               InputLabelProps={{
//                 sx: {
//                   "& .MuiFormLabel-asterisk": { color: "red" }
//                 }
//               }}
//               inputRef={cardNumberRef}
//               onChange={(e) => setErrors({ ...errors, id_card: "" })}
//             />
//             {role !== "CLIENT" && errors?.id_card && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2 }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.id_card}
//               </Typography>
//             )}
//             </>
//            )} */}
//             <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//               <FormLabel component="legend" sx={{ marginRight: "1rem", fontSize: "0.9rem" }}>
//                 {t("Gender")}
//               </FormLabel>
//               <FormControl component="fieldset">
//                 <RadioGroup
//                   name="gender"
//                   value={gender}
//                   onChange={handleGenderChange}
//                   sx={{ flexDirection: "row", "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }}
//                 >
//                   <FormControlLabel
//                     value="M"
//                     control={<Radio size="small" />}
//                     label={t("Male")}
//                   />
//                   <FormControlLabel
//                     value="F"
//                     control={<Radio size="small" />}
//                     label={t("Female")}
//                   />
//                 </RadioGroup>
//               </FormControl>
//             </Box>
//             <TextField
//               fullWidth
//               label={t("Email")}
//               variant="outlined"
//               type="email"
//               inputRef={emailRef}
//               InputLabelProps={{
//                 required: true,
//                 sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
//               }}
//               InputProps={{
//                 sx: { fontSize: "0.9rem" },
//               }}
//               onChange={(e) => setErrors({ ...errors, email: "" })}
//             />
//             {errors?.email && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.email}
//               </Typography>
//             )}
//             {/* <TextField
//               fullWidth
//               label={t("Username")}
//               variant="outlined"
//               inputRef={usernameRef}
//               InputLabelProps={{
//                 required: true,
//                 sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
//               }}
//               InputProps={{
//                 sx: { fontSize: "0.9rem" },
//               }}
//               onChange={(e) => setErrors({ ...errors, username: "" })}
//             />
//             {errors?.username && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.username}
//               </Typography>
//             )} */}
//             <TextField
//               fullWidth
//               label={t("Password")}
//               variant="outlined"
//               type={showPassword ? "text" : "password"}
//               inputRef={passwordRef}
//               InputLabelProps={{
//                 required: true,
//                 sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
//               }}
//               onChange={(e) => setErrors({ ...errors, password: "" })}
//               InputProps={{
//                 sx: { fontSize: "0.9rem" },
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       aria-label="toggle password visibility"
//                       onClick={handleClickShowPassword}
//                       edge="end"
//                       size="small"
//                     >
//                       {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
//                     </IconButton>
//                   </InputAdornment>
//                 )
//               }}
//             />
//             {errors?.password && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.password}
//               </Typography>
//             )}

//             {(role === "STAFF") && (
//               <>
//                 <Typography
//                   sx={{ textAlign: "left", mt: 3, fontSize: "0.9rem" }}
//                   variant="body1"
//                   gutterBottom
//                 >
//                   {t("Pick a color for the appointment")}:
//                 </Typography>
//                 <SketchPicker
//                   color={color}
//                   onChangeComplete={(newColor) => setColor(newColor.hex)}
//                 />{" "}
//               </>
//             )}
//           </Box>
//           <Button
//             sx={{ mb: 2, mt: 4, fontSize: "0.9rem", padding: "6px 12px" }}
//             type="submit"
//             variant="contained"
//             color="primary"
//           >
//             {t("Submit")}
//           </Button>
//           <Button
//             sx={{ mb: 2, ml: 2, mt: 4, fontSize: "0.9rem", padding: "6px 12px" }}
//             type="button"
//             variant="outlined"
//             color="secondary"
//             onClick={handleReset}
//           >
//             {t("Reset")}
//           </Button>

//           {/* {message && (
//             <Typography variant="body1" color="green" gutterBottom>
//               {message}
//             </Typography>
//           )} */}
//           {message && (
//             <Box sx={{ my: 2 }}>
//               <Alert severity="success" sx={{ fontSize: "0.9rem" }}>
//                 {message}
//               </Alert>
//             </Box>
//           )}
//           {error && (
//             <Box sx={{ my: 2 }}>
//               <Alert severity="error" sx={{ fontSize: "0.9rem" }}>
//                 {error}
//               </Alert>
//             </Box>
//           )}
//         </form>
//       </CardContent>
//     </Card >
//   );
// };

// export default UserForm;


// // src/screens/new_client.screen.jsx
// import GDPRPolicyLink from "../components/GDPRPolicyLink";

// import { useState, useRef } from "react";
// import { useStateContext } from "../context/ContextProvider";
// import {
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormControl,
//   FormLabel,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   InputAdornment,
//   Checkbox,
//   Alert,
// } from "@mui/material";
// import { SketchPicker } from "react-color";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import PhoneField from "../components/PhoneField";
// import { IconButton } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// const UserForm = () => {
//   const nameRef = useRef(null);
//   const surnameRef = useRef(null);
//   const dateRef = useRef(null);
//   // const usernameRef = useRef(null);
//   const passwordRef = useRef(null);
//   const emailRef = useRef(null);
//   const addressRef = useRef(null);
//   const gesyNumberRef = useRef(null);

//   const postalRef = useRef(null);
//   const cityRef = useRef(null);
//   const cardNumberRef = useRef();
//   const [gender, setGender] = useState("");
//   const [role, setRole] = useState("CLIENT");
//   const [error, setError] = useState();
//   const [message, setMessage] = useState();
//   const [color, setColor] = useState("");
//   const [phone, setPhone] = useState("+357");
//   const [hardcopyConsent, setHardcopyConsent] = useState(false);

//   const [errors, setErrors] = useState({});

//   const { token } = useStateContext();
//   const { t } = useTranslation();
//   const [showPassword, setShowPassword] = useState(false);

//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();

//     let phoneNumber = "+" + phone;

//     if (dateRef.current.value && !/^\d{4}-\d{2}-\d{2}$/.test(dateRef.current.value)) {
//       setErrors({ ...errors, date_birth: "Invalid date format. Use YYYY-MM-DD" });
//       return;
//     }
//     let localErrors = {};
//     // const usernameVal = usernameRef.current.value;
//     const passwordVal = passwordRef.current.value;
//     const nameVal = nameRef.current.value;
//     const surnameVal = surnameRef.current.value;
//     const emailVal = emailRef.current.value;
//     const phoneVal = phone;

//     // const usernameHasTwoDigits = (usernameVal.match(/\d/g) || []).length >= 2;

//     // if (!usernameVal) {
//     //   localErrors.username = "Username is required";
//     // } else if (usernameVal.length < 3 || !usernameHasTwoDigits) {
//     //   localErrors.username = "Username must be at least 3 characters and contain at least 2 digits";
//     // }

//     if (!passwordVal) {
//       localErrors.password = "Password is required";
//     } else if (
//       passwordVal.length < 8 ||
//       !/[!@#$%^&*(),.?":{}|<>]/.test(passwordVal)
//     ) {
//       localErrors.password =
//         "Password must be at least 8 characters long with at least 1 special character";
//     }

//     if (!nameVal || nameVal.length < 2)
//       localErrors.first_name = "First name must be at least 2 characters";
//     if (!surnameVal || surnameVal.length < 2)
//       localErrors.last_name = "Last name must be at least 2 characters";

//     if (!emailVal) {
//       localErrors.email = "Email is required";
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
//       localErrors.email = "Invalid email format";
//     }

//     if (!phoneVal || phoneVal.trim() === "" || phoneVal === "+357") {
//       localErrors.phone_number = "Phone number is required";
//     }

//     if (Object.keys(localErrors).length) {
//       setErrors(localErrors);
//       return;
//     }

//     const payload = {
//       user_role: role,
//       username: emailRef.current.value,
//       password: passwordRef.current.value,
//       first_name: nameRef.current.value,
//       last_name: surnameRef.current.value,
//       email: emailRef.current.value,
//       date_birth: dateRef.current.value || null,
//       hardcopy_consent: hardcopyConsent,
//       gender: gender,
//       phone_number: phoneNumber,
//       ...(role !== "CLIENT" &&
//         role !== "ADMIN" && {
//           // id_card: cardNumberRef.current.value,
//           // city: cityRef.current?.value || "",
//           // address: addressRef.current?.value || "",
//           // postcode: postalRef.current?.value || "",
//           gesy_number: gesyNumberRef.current?.value || "",
//           color: color,
//         }),
//     };

//     axiosClient
//       .post("/api/user/", payload, {
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "*/*",
//           Authorization: `JWT-${token}`,
//         },
//       })
//       .then((res) => {
//         console.log("res", res);
//         setError({});
//         setMessage("User added successfully");
//         setError();
//         // usernameRef.current.value = null;
//         passwordRef.current.value = null;
//         if (cardNumberRef.current) cardNumberRef.current.value = null;
//         setHardcopyConsent(false);
//         nameRef.current.value = null;
//         surnameRef.current.value = null;
//         emailRef.current.value = null;
//         dateRef.current.value = null;
//         setGender("");
//         if (cityRef.current) cityRef.current.value = null;
//         if (addressRef.current) addressRef.current.value = null;
//         if (postalRef.current) postalRef.current.value = null;
//         if (gesyNumberRef.current) gesyNumberRef.current.value = null;
//         setPhone("+357");
//         setColor("");
//       })
//       .catch((err) => {
//         const allIssues = Object.keys(err.response?.data || {});
//         if (err?.response?.data?.code) {
//           setError(err.response.data.code);
//           return;
//         }
//         setError(
//           allIssues.length
//             ? err.response?.data[allIssues[0]][0] ||
//               "Some input is invalid! please try again"
//             : "Some input is invalid! please try again"
//         );
//         console.log("error when creating new user", err);
//         setErrors(err.response?.data);
//       });
//   };

//   const handleReset = () => {
//     setRole("CLIENT");
//     setShowPassword(false);
//     setGender("");
//     setPhone("+357");
//     setColor("");
//     setError(undefined);
//     setMessage(undefined);
//     setErrors({});
//     setHardcopyConsent(false);

//     const refs = [
//       nameRef,
//       surnameRef,
//       dateRef,
//       // usernameRef,
//       passwordRef,
//       emailRef,
//       addressRef,
//       gesyNumberRef,
//       postalRef,
//       cityRef,
//       cardNumberRef,
//     ];

//     refs.forEach((ref) => {
//       if (ref.current) ref.current.value = "";
//     });
//   };

//   const handleGenderChange = (event) => {
//     setGender(event.target.value);
//   };

//   const handleRoleChange = (event) => {
//     setRole(event.target.value);
//     setErrors({ ...errors, user_role: "" });
//   };

//   return (
//     <Card elevation={16}>
//       <CardContent>
//         <Typography variant="h5" gutterBottom sx={{ fontSize: "1.2rem" }}>
//           {t("Information")}
//         </Typography>
//         <form onSubmit={handleSubmit}>
//           <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
//             <FormLabel component="legend" sx={{ mr: 2, fontSize: "0.9rem" }}>
//               {t("Role")}
//             </FormLabel>
//             <RadioGroup
//               name="role"
//               value={role}
//               onChange={handleRoleChange}
//               row
//               sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }}
//             >
//               <FormControlLabel
//                 value="ADMIN"
//                 control={<Radio size="small" />}
//                 label={t("Secretary")}
//               />
//               <FormControlLabel
//                 value="STAFF"
//                 control={<Radio size="small" />}
//                 label={t("Doctor")}
//               />
//               <FormControlLabel
//                 value="CLIENT"
//                 control={<Radio size="small" />}
//                 label={t("Patient")}
//               />
//             </RadioGroup>
//           </Box>

//           {errors?.user_role && (
//             <Typography
//               sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//               color="error"
//               variant="body1"
//             >
//               {errors?.user_role}
//             </Typography>
//           )}

//           {/* Hardcopy Consent + GDPR Policy link */}
//           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={hardcopyConsent}
//                   onChange={(e) => setHardcopyConsent(e.target.checked)}
//                   size="small"
//                 />
//               }
//               label={t("Hardcopy Consent")}
//               sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }}
//             />
//           </Box>

//           <Box sx={{ mb: 2 }}>
//             <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
//               <GDPRPolicyLink />
//             </Typography>
//           </Box>

//           <Box sx={{ "& .MuiTextField-root": { marginBottom: "0.8rem" } }}>
//             <TextField
//               fullWidth
//               label={t("Name")}
//               variant="outlined"
//               inputRef={nameRef}
//               InputLabelProps={{
//                 required: true,
//                 sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
//               }}
//               InputProps={{
//                 sx: { fontSize: "0.9rem" },
//               }}
//               onChange={(e) => setErrors({ ...errors, first_name: "" })}
//             />
//             {errors?.first_name && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.first_name}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               label={t("Surname")}
//               variant="outlined"
//               inputRef={surnameRef}
//               InputLabelProps={{
//                 required: true,
//                 sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
//               }}
//               InputProps={{
//                 sx: { fontSize: "0.9rem" },
//               }}
//               onChange={(e) => setErrors({ ...errors, last_name: "" })}
//             />
//             {errors?.last_name && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.last_name}
//               </Typography>
//             )}
//             <TextField
//               fullWidth
//               type="date"
//               label={t("Date of Birth")}
//               variant="outlined"
//               InputLabelProps={{
//                 shrink: true,
//                 sx: { fontSize: "0.9rem" },
//               }}
//               inputRef={dateRef}
//               onChange={(e) => setErrors({ ...errors, date_birth: "" })}
//               InputProps={{
//                 sx: {
//                   fontSize: "0.9rem",
//                   "&::-webkit-calendar-picker-indicator": {
//                     filter: "invert(1)",
//                   },
//                 },
//               }}
//             />
//             {errors?.date_birth && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.date_birth}
//               </Typography>
//             )}

//             <PhoneField
//               phone={phone}
//               setPhone={(val) => {
//                 setPhone(val);
//                 setErrors((prev) => ({ ...prev, phone_number: "" }));
//               }}
//               textFieldProps={{
//                 InputLabelProps: { sx: { fontSize: "0.9rem" } },
//                 InputProps: { sx: { fontSize: "0.9rem" } },
//               }}
//             />
//             {errors?.phone_number && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.phone_number}
//               </Typography>
//             )}

//             <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//               <FormLabel
//                 component="legend"
//                 sx={{ marginRight: "1rem", fontSize: "0.9rem" }}
//               >
//                 {t("Gender")}
//               </FormLabel>
//               <FormControl component="fieldset">
//                 <RadioGroup
//                   name="gender"
//                   value={gender}
//                   onChange={handleGenderChange}
//                   sx={{
//                     flexDirection: "row",
//                     "& .MuiFormControlLabel-label": { fontSize: "0.9rem" },
//                   }}
//                 >
//                   <FormControlLabel
//                     value="M"
//                     control={<Radio size="small" />}
//                     label={t("Male")}
//                   />
//                   <FormControlLabel
//                     value="F"
//                     control={<Radio size="small" />}
//                     label={t("Female")}
//                   />
//                 </RadioGroup>
//               </FormControl>
//             </Box>
//             <TextField
//               fullWidth
//               label={t("Email")}
//               variant="outlined"
//               type="email"
//               inputRef={emailRef}
//               InputLabelProps={{
//                 required: true,
//                 sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
//               }}
//               InputProps={{
//                 sx: { fontSize: "0.9rem" },
//               }}
//               onChange={(e) => setErrors({ ...errors, email: "" })}
//             />
//             {errors?.email && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.email}
//               </Typography>
//             )}

//             <TextField
//               fullWidth
//               label={t("Password")}
//               variant="outlined"
//               type={showPassword ? "text" : "password"}
//               inputRef={passwordRef}
//               InputLabelProps={{
//                 required: true,
//                 sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
//               }}
//               onChange={(e) => setErrors({ ...errors, password: "" })}
//               InputProps={{
//                 sx: { fontSize: "0.9rem" },
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       aria-label="toggle password visibility"
//                       onClick={handleClickShowPassword}
//                       edge="end"
//                       size="small"
//                     >
//                       {showPassword ? (
//                         <VisibilityOff fontSize="small" />
//                       ) : (
//                         <Visibility fontSize="small" />
//                       )}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             {errors?.password && (
//               <Typography
//                 sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }}
//                 color="error"
//                 variant="body1"
//               >
//                 {errors?.password}
//               </Typography>
//             )}

//             {role === "STAFF" && (
//               <>
//                 <Typography
//                   sx={{ textAlign: "left", mt: 3, fontSize: "0.9rem" }}
//                   variant="body1"
//                   gutterBottom
//                 >
//                   {t("Pick a color for the appointment")}:
//                 </Typography>
//                 <SketchPicker
//                   color={color}
//                   onChangeComplete={(newColor) => setColor(newColor.hex)}
//                 />{" "}
//               </>
//             )}
//           </Box>
//           <Button
//             sx={{ mb: 2, mt: 4, fontSize: "0.9rem", padding: "6px 12px" }}
//             type="submit"
//             variant="contained"
//             color="primary"
//           >
//             {t("Submit")}
//           </Button>
//           <Button
//             sx={{ mb: 2, ml: 2, mt: 4, fontSize: "0.9rem", padding: "6px 12px" }}
//             type="button"
//             variant="outlined"
//             color="secondary"
//             onClick={handleReset}
//           >
//             {t("Reset")}
//           </Button>

//           {message && (
//             <Box sx={{ my: 2 }}>
//               <Alert severity="success" sx={{ fontSize: "0.9rem" }}>
//                 {message}
//               </Alert>
//             </Box>
//           )}
//           {error && (
//             <Box sx={{ my: 2 }}>
//               <Alert severity="error" sx={{ fontSize: "0.9rem" }}>
//                 {error}
//               </Alert>
//             </Box>
//           )}
//         </form>
//       </CardContent>
//     </Card>
//   );
// };

// export default UserForm;


// src/screens/new_client.screen.jsx
import GDPRPolicyLink from "../components/GDPRPolicyLink";

import { useState, useRef } from "react";
import { useStateContext } from "../context/ContextProvider";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
  Checkbox,
  Alert,
  IconButton,
} from "@mui/material";
import { SketchPicker } from "react-color";
import axiosClient from "../axiosClient";
import { useTranslation } from "react-i18next";
import PhoneField from "../components/PhoneField";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const UserForm = () => {
  const nameRef = useRef(null);
  const surnameRef = useRef(null);
  const dateRef = useRef(null);
  const passwordRef = useRef(null);
  const emailRef = useRef(null);
  const addressRef = useRef(null);
  const gesyNumberRef = useRef(null);

  const postalRef = useRef(null);
  const cityRef = useRef(null);
  const cardNumberRef = useRef(null);

  const [gender, setGender] = useState("");
  // ✅ Default role changed so it doesn't default to Patient
  const [role, setRole] = useState("ADMIN");

  const [error, setError] = useState();
  const [message, setMessage] = useState();
  const [color, setColor] = useState("");
  const [phone, setPhone] = useState("+357");
  const [hardcopyConsent, setHardcopyConsent] = useState(false);

  const [errors, setErrors] = useState({});

  const { token } = useStateContext();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((v) => !v);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const phoneNumber = "+" + phone;

    if (
      dateRef.current.value &&
      !/^\d{4}-\d{2}-\d{2}$/.test(dateRef.current.value)
    ) {
      setErrors({ ...errors, date_birth: "Invalid date format. Use YYYY-MM-DD" });
      return;
    }

    let localErrors = {};
    const passwordVal = passwordRef.current.value;
    const nameVal = nameRef.current.value;
    const surnameVal = surnameRef.current.value;
    const emailVal = emailRef.current.value;
    const phoneVal = phone;

    if (!passwordVal) {
      localErrors.password = "Password is required";
    } else if (passwordVal.length < 8 || !/[!@#$%^&*(),.?":{}|<>]/.test(passwordVal)) {
      localErrors.password =
        "Password must be at least 8 characters long with at least 1 special character";
    }

    if (!nameVal || nameVal.length < 2)
      localErrors.first_name = "First name must be at least 2 characters";
    if (!surnameVal || surnameVal.length < 2)
      localErrors.last_name = "Last name must be at least 2 characters";

    if (!emailVal) {
      localErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
      localErrors.email = "Invalid email format";
    }

    if (!phoneVal || phoneVal.trim() === "" || phoneVal === "+357") {
      localErrors.phone_number = "Phone number is required";
    }

    if (Object.keys(localErrors).length) {
      setErrors(localErrors);
      return;
    }

    const payload = {
      user_role: role,
      username: emailRef.current.value,
      password: passwordRef.current.value,
      first_name: nameRef.current.value,
      last_name: surnameRef.current.value,
      email: emailRef.current.value,
      date_birth: dateRef.current.value || null,
      hardcopy_consent: hardcopyConsent,
      gender: gender,
      phone_number: phoneNumber,
      ...(role !== "CLIENT" &&
        role !== "ADMIN" && {
          gesy_number: gesyNumberRef.current?.value || "",
          color: color,
        }),
    };

    axiosClient
      .post("/api/user/", payload, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `JWT-${token}`,
        },
      })
      .then((res) => {
        console.log("res", res);
        setErrors({});
        setMessage("User added successfully");
        setError(undefined);

        passwordRef.current.value = "";
        if (cardNumberRef.current) cardNumberRef.current.value = "";
        setHardcopyConsent(false);
        nameRef.current.value = "";
        surnameRef.current.value = "";
        emailRef.current.value = "";
        dateRef.current.value = "";
        setGender("");
        if (cityRef.current) cityRef.current.value = "";
        if (addressRef.current) addressRef.current.value = "";
        if (postalRef.current) postalRef.current.value = "";
        if (gesyNumberRef.current) gesyNumberRef.current.value = "";
        setPhone("+357");
        setColor("");
      })
      .catch((err) => {
        const allIssues = Object.keys(err.response?.data || {});
        if (err?.response?.data?.code) {
          setError(err.response.data.code);
          return;
        }
        setError(
          allIssues.length
            ? err.response?.data[allIssues[0]][0] || "Some input is invalid! please try again"
            : "Some input is invalid! please try again"
        );
        console.log("error when creating new user", err);
        setErrors(err.response?.data);
      });
  };

  const handleReset = () => {
    // ✅ Reset to ADMIN (not CLIENT)
    setRole("ADMIN");
    setShowPassword(false);
    setGender("");
    setPhone("+357");
    setColor("");
    setError(undefined);
    setMessage(undefined);
    setErrors({});
    setHardcopyConsent(false);

    const refs = [
      nameRef,
      surnameRef,
      dateRef,
      passwordRef,
      emailRef,
      addressRef,
      gesyNumberRef,
      postalRef,
      cityRef,
      cardNumberRef,
    ];

    refs.forEach((ref) => {
      if (ref.current) ref.current.value = "";
    });
  };

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const handleRoleChange = (event) => {
    setRole(event.target.value);
    setErrors((prev) => ({ ...prev, user_role: "" }));
  };

  return (
    <Card elevation={16}>
      <CardContent>
        <Typography variant="h5" gutterBottom sx={{ fontSize: "1.2rem" }}>
          {t("Information")}
        </Typography>

        <form onSubmit={handleSubmit}>
          <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
            <FormLabel component="legend" sx={{ mr: 2, fontSize: "0.9rem" }}>
              {t("Role")}
            </FormLabel>

            <RadioGroup
              name="role"
              value={role}
              onChange={handleRoleChange}
              row
              sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }}
            >
              <FormControlLabel
                value="ADMIN"
                control={<Radio size="small" />}
                label={t("ADMIN")}
              />
              <FormControlLabel
                value="STAFF"
                control={<Radio size="small" />}
                label={t("STAFF")}
              />

              {/* ✅ Patient removed */}
            </RadioGroup>
          </Box>

          {errors?.user_role && (
            <Typography sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }} color="error">
              {errors?.user_role}
            </Typography>
          )}

          {/* Hardcopy Consent + GDPR Policy link */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={hardcopyConsent}
                  onChange={(e) => setHardcopyConsent(e.target.checked)}
                  size="small"
                />
              }
              label={t("Hardcopy Consent")}
              sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
              <GDPRPolicyLink />
            </Typography>
          </Box>

          <Box sx={{ "& .MuiTextField-root": { marginBottom: "0.8rem" } }}>
            <TextField
              fullWidth
              label={t("Name")}
              variant="outlined"
              inputRef={nameRef}
              InputLabelProps={{
                required: true,
                sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
              }}
              InputProps={{ sx: { fontSize: "0.9rem" } }}
              onChange={() => setErrors((prev) => ({ ...prev, first_name: "" }))}
            />
            {errors?.first_name && (
              <Typography sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }} color="error">
                {errors?.first_name}
              </Typography>
            )}

            <TextField
              fullWidth
              label={t("Surname")}
              variant="outlined"
              inputRef={surnameRef}
              InputLabelProps={{
                required: true,
                sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
              }}
              InputProps={{ sx: { fontSize: "0.9rem" } }}
              onChange={() => setErrors((prev) => ({ ...prev, last_name: "" }))}
            />
            {errors?.last_name && (
              <Typography sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }} color="error">
                {errors?.last_name}
              </Typography>
            )}

            <TextField
              fullWidth
              type="date"
              label={t("Date of Birth")}
              variant="outlined"
              InputLabelProps={{ shrink: true, sx: { fontSize: "0.9rem" } }}
              inputRef={dateRef}
              onChange={() => setErrors((prev) => ({ ...prev, date_birth: "" }))}
              InputProps={{
                sx: {
                  fontSize: "0.9rem",
                  "&::-webkit-calendar-picker-indicator": { filter: "invert(1)" },
                },
              }}
            />
            {errors?.date_birth && (
              <Typography sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }} color="error">
                {errors?.date_birth}
              </Typography>
            )}

            <PhoneField
              phone={phone}
              setPhone={(val) => {
                setPhone(val);
                setErrors((prev) => ({ ...prev, phone_number: "" }));
              }}
              textFieldProps={{
                InputLabelProps: { sx: { fontSize: "0.9rem" } },
                InputProps: { sx: { fontSize: "0.9rem" } },
              }}
            />
            {errors?.phone_number && (
              <Typography sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }} color="error">
                {errors?.phone_number}
              </Typography>
            )}

            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <FormLabel component="legend" sx={{ marginRight: "1rem", fontSize: "0.9rem" }}>
                {t("Gender")}
              </FormLabel>
              <FormControl component="fieldset">
                <RadioGroup
                  name="gender"
                  value={gender}
                  onChange={handleGenderChange}
                  sx={{
                    flexDirection: "row",
                    "& .MuiFormControlLabel-label": { fontSize: "0.9rem" },
                  }}
                >
                  <FormControlLabel value="M" control={<Radio size="small" />} label={t("Male")} />
                  <FormControlLabel
                    value="F"
                    control={<Radio size="small" />}
                    label={t("Female")}
                  />
                </RadioGroup>
              </FormControl>
            </Box>

            <TextField
              fullWidth
              label={t("Email")}
              variant="outlined"
              type="email"
              inputRef={emailRef}
              InputLabelProps={{
                required: true,
                sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
              }}
              InputProps={{ sx: { fontSize: "0.9rem" } }}
              onChange={() => setErrors((prev) => ({ ...prev, email: "" }))}
            />
            {errors?.email && (
              <Typography sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }} color="error">
                {errors?.email}
              </Typography>
            )}

            <TextField
              fullWidth
              label={t("Password")}
              variant="outlined"
              type={showPassword ? "text" : "password"}
              inputRef={passwordRef}
              InputLabelProps={{
                required: true,
                sx: { "& .MuiFormLabel-asterisk": { color: "red" }, fontSize: "0.9rem" },
              }}
              onChange={() => setErrors((prev) => ({ ...prev, password: "" }))}
              InputProps={{
                sx: { fontSize: "0.9rem" },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? (
                        <VisibilityOff fontSize="small" />
                      ) : (
                        <Visibility fontSize="small" />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {errors?.password && (
              <Typography sx={{ textAlign: "left", mb: 2, fontSize: "0.8rem" }} color="error">
                {errors?.password}
              </Typography>
            )}

            {role === "STAFF" && (
              <>
                <Typography sx={{ textAlign: "left", mt: 3, fontSize: "0.9rem" }} gutterBottom>
                  {t("Pick a color for the appointment")}:
                </Typography>
                <SketchPicker color={color} onChangeComplete={(newColor) => setColor(newColor.hex)} />
              </>
            )}
          </Box>

          <Button sx={{ mb: 2, mt: 4, fontSize: "0.9rem", padding: "6px 12px" }} type="submit" variant="contained">
            {t("Submit")}
          </Button>

          <Button
            sx={{ mb: 2, ml: 2, mt: 4, fontSize: "0.9rem", padding: "6px 12px" }}
            type="button"
            variant="outlined"
            color="secondary"
            onClick={handleReset}
          >
            {t("Reset")}
          </Button>

          {message && (
            <Box sx={{ my: 2 }}>
              <Alert severity="success" sx={{ fontSize: "0.9rem" }}>
                {message}
              </Alert>
            </Box>
          )}

          {error && (
            <Box sx={{ my: 2 }}>
              <Alert severity="error" sx={{ fontSize: "0.9rem" }}>
                {error}
              </Alert>
            </Box>
          )}
        </form>
      </CardContent>
    </Card>
  );
};

export default UserForm;